import React from 'react';

import { graphql, useRefetchableFragment } from 'react-relay';
import { MenuList, MenuSection } from '@atlaskit/navigation-system';
import type { SubspaceMenuList$key } from './__generated__/SubspaceMenuList.graphql';
import { SubspaceMenuItem } from './SubspaceMenuItem.tsx';
import type { SubspaceMenuListRefetchQuery } from './__generated__/SubspaceMenuListRefetchQuery.graphql';

type SubspaceItemsProps = {
	queryRef: SubspaceMenuList$key;
};

export const SubspaceMenuList = ({ queryRef }: SubspaceItemsProps): JSX.Element => {
	const [project] = useRefetchableFragment<SubspaceMenuListRefetchQuery, SubspaceMenuList$key>(
		graphql`
			fragment SubspaceMenuList on JiraProject
			@refetchable(queryName: "SubspaceMenuListRefetchQuery") {
				subspaces_cse {
					edges {
						node {
							name
							subspaceUrl
						}
					}
				}
			}
		`,
		queryRef,
	);

	const subspaces = project?.subspaces_cse?.edges?.map((edge) => ({
		projectName: edge?.node?.name || '',
		href: edge?.node?.subspaceUrl || '',
	}));

	if (!subspaces) {
		return <></>;
	}

	return (
		<MenuSection>
			<MenuList>
				{subspaces?.map((subspace) => (
					<SubspaceMenuItem key={subspace.projectName} {...subspace} />
				))}
			</MenuList>
		</MenuSection>
	);
};
